import React from "react";
import { Link, useLocation } from "react-router-dom";
import contentData from "../content.json";
import { Fade } from "react-awesome-reveal";

/*
 * This section checks if the section_enabled is true or false
 * and if true then the item inside the navbar is
 */

const Navbar = () => {
  const location = useLocation();

  const sections = [
    {
      id: "aboutme",
      text: contentData.about_me.section.navbar_name,
      enable: contentData.about_me.section.enable_section,
    },
    {
      id: "education",
      text: contentData.academics.section.navbar_name,
      enable: contentData.academics.section.enable_section,
    },
    {
      id: "experience",
      text: contentData.experience.section.navbar_name,
      enable: contentData.experience.section.enable_section,
    },
    {
      id: "trading",
      text: contentData.trading.section.navbar_name,
      enable: contentData.trading.section.enable_section,
    },
    {
      id: "projects",
      text: contentData.projects.section.navbar_name,
      enable: contentData.projects.section.enable_section,
    },
  ];

  const handleHomeClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.history.replaceState(null, "", "/");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleSectionClick = (e, id) => {
    if (location.pathname === "/") {
      e.preventDefault();
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      window.history.replaceState(null, "", `/#${id}`);
    }
  };

  return (
    <div className="navlist">
      <Fade cascade damping={0.2} triggerOnce={true}>
        <ul>
          <li>
            <Link to="/" onClick={handleHomeClick}>
              /Home
            </Link>
          </li>
          <li>
            <Link to="/coaching">/Coaching</Link>
          </li>
          {sections.map((section) => {
            return section.enable ? (
              <li key={section.id}>
                <Link
                  to={`/#${section.id}`}
                  onClick={(e) => handleSectionClick(e, section.id)}
                >
                  {section.text}
                </Link>
              </li>
            ) : null;
          })}
        </ul>
      </Fade>
    </div>
  );
};

export default Navbar;
